import React, { useState, useEffect } from "react";
import Multiselect from 'multiselect-react-dropdown';
import {
  Table,
  Form,
  Col,
} from "react-bootstrap";
import "./Tasks.css";
import { useAuth } from "../../ProtectedRoute/AppContext";
import { toast, ToastContainer } from "react-toastify";
import AxiosInstance from "../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../Services/TaskService";
import { useNavigate } from "react-router";
import Loader from "../../DesignLayout/Loader/Loader";
const Tasks = () => {
  const { user } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [project, setProject] = useState([]);
  // Modal for editing tasks
  const [Loading,setLoading]=useState(false);
  const navigate=useNavigate();
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [projectFilter, setprojectFilter] = useState("");
  const [priorityFilter, setPriorityFilter] = useState("");
  const [priority, setPriority] = useState([]);
  const [users, setUsers] = useState([]);
  const [dueDateFilter, setDueDateFilter] = useState("");
const[status,setstatus]=useState("");
  const [statusfilter, setstatusfilter] = useState("");
  const [newTask, setNewtask] = useState({
    taskName: "",
    project: 0,
    createdBy: user.userId,
    assignedToPerson: "",
    dueDate: '',
    status: 1,
    priority: 1,
    description: "",
    expectedDate: null,
    testers:0
   // note:"",
  });
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 12; // Number of items per page
const maxPageButtons = 10; // Maximum page buttons to display

const totalPages = Math.ceil(filteredTasks.length / itemsPerPage);

// Slice the tasks for the current page
const currentTasks = filteredTasks.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

// Function to handle page change
const handlePageChange = (pageNumber) => {
  if (pageNumber >= 1 && pageNumber <= totalPages) {
    setCurrentPage(pageNumber);
  }
};

// Generate page numbers dynamically
const generatePageNumbers = () => {
  const startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
  const endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
  return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
};

  useEffect(() => {
    const fetchTasks = async () => {
      const params = { userId: user.sessionId };
        try {
          const response= await AxiosInstance.get(`${API_ENDPOINTS.GET_TASKS_REPORT}?userId=${user.sessionId}`);
          const tasksById = response.data.tasksById || [] ;
          const taskData = response.data.tasks || [];
          console.log(tasksById);
          if(tasksById.length > 0){
            setTasks(tasksById);
            setFilteredTasks(tasksById);
          }
          else if(taskData.length > 0){
            setTasks(taskData);
            setFilteredTasks(taskData);
          }else
          {
            setTasks([]);
            setFilteredTasks([]);
          }
          setstatus(response.data.status)
          setPriority(response.data.priority);
          setUsers(response.data.users);
          setProject(response.data.projects || []);
         // setTasks(response.data.tasks || []);
         // setFilteredTasks(response.data.tasksById);
         //console.log("Priority Response:", priorityresponse.data);
        } catch (error) {
          console.error(error);
          setFilteredTasks([]);
        }
    };
    fetchTasks();
  }, [user.userId]);
   
  const getStatusName = (statusId) => {
    const statusObj = status.find((item) => item.id === statusId);
    return statusObj ? statusObj.name : "Unknown"; // Fallback to "Unknown"
  };
  
  const getPriorityName = (priorityId) => {
    const priorityObj = priority.find((item) => item.id === priorityId);
    return priorityObj ? priorityObj.name : "Unknown";
  };
  
  const getAssignedToName = (userId) => {
    const userObj = users.find((item) => item.userId === parseInt(userId));
    return userObj ? userObj.userName : "Unassigned";
  };
// Filter tasks based on search query, priority, and due date

const getPriorityColor = (priority) => {
  switch (priority) {
    case "High":
    case "1":
      return "#d32121";
    case "Medium":
    case "2":
      return "#d4f004";
    case "Low":
    case "3":
      return "#04f0d1";
    case "Critical":
    case "4":
      return "#f00404";
    default:
      return "#dc3545";
  }
};
// const [currentPage, setCurrentPage] = useState(1);
// const itemsPerPage = 16; // Number of items per page
// const maxPageButtons = 5; 

// const totalPages = Math.ceil(filteredTasks.length / itemsPerPage);
//   const currentProjects = filteredTasks.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   const generatePageNumbers = () => {
//     const startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
//     const endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
//     return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
//   };

useEffect(() => {
 
  let updatedTasks = [...tasks];

  if (searchQuery) {
    updatedTasks = updatedTasks.filter((task) =>
      task.taskName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  if (priorityFilter) {
    updatedTasks = updatedTasks.filter((task) => task.priority === priorityFilter);
  }
  if (projectFilter) {
    updatedTasks = updatedTasks.filter((task) => task.project === projectFilter);
  }

  if (dueDateFilter) {
    updatedTasks = updatedTasks.filter(
      (task) => new Date(task.dueDate).toISOString().split("T")[0] === dueDateFilter
    );
  }

  if(statusfilter){
    updatedTasks = updatedTasks.filter((task) => task.status === statusfilter);
  }

  setFilteredTasks(updatedTasks);
}, [searchQuery, priorityFilter, projectFilter , dueDateFilter, statusfilter, tasks]);

  // Handle the task update
  const handleModalClose = () => {
    setShowBugSession(false);
  };
  const [showProjectSession, setShowBugSession] = useState(false); // Track which section to show

  // Update this in the onClick event of the "Create Bug" button
  const handleCreate = () => {
    setShowBugSession(true); // Show bug section
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewtask((prev) => ({
      ...prev,
      [name]: value || prev[name], // Ensure existing values are retained if input is empty
    }));
  };
  const assignedTobug = String(newTask.assignedToPerson || ''); // Fallback to empty string if undefined
  const selectedUserstask = users.filter((user) => { 
    return user.userId && assignedTobug.split(',').includes(user.userId.toString());
  });
  
   // Handle selection
   const onUserSelect = (selectedList) => {
    // Join selected user ids into a comma-separated string
    const selectedUserIds = selectedList.map((item) => item.userId).join(',');
    setNewtask((prevTask) => ({
      ...prevTask,
      assignedToPerson: selectedUserIds, // Store as a string
    }));
  };
  
  // Handle removal
  const onUserRemove = (selectedList) => {
    // Join remaining selected user ids into a comma-separated string
    const selectedUserIds = selectedList.map((item) => item.userId).join(',');
    setNewtask((prevTask) => ({
      ...prevTask,
      assignedToPerson: selectedUserIds, // Store as a string
    }));
  };

  const AddTask= async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      console.log(newTask);
      const response = await AxiosInstance.post(API_ENDPOINTS.ADD_TASK, newTask);
      if (response.data) {
        
        sessionStorage.setItem("taskMessage","task created successfully");
        handleModalClose();
        window.location.reload();
      } else {
        toast.error(response.data);
      }
    } catch (error) {
      toast.error("Invalid Task Details");
      console.log(newTask);
    }
    finally{
      setLoading(false);
    }
  };

  useEffect(() => {
        const message = sessionStorage.getItem("taskMessage");
        if (message) {
            toast.success(message);
            sessionStorage.removeItem("taskMessage"); // Clear after showing
        }
      //   const updatetask=localStorage.getItem("taskuMessage");
      //   if (updatetask) {
      //     toast.success(updatetask);
      //     localStorage.removeItem("taskMessage"); // Clear after showing
      // }
    }, []);
    useEffect(() => {
      const message = localStorage.getItem("bugtMessage");
      if (message) {
          toast.success(message);
          localStorage.removeItem("bugtMessage"); // Clear after showing
      }
    }, []);
  const handleclick=(taskId)=>{
   
      navigate('/taskdetails',{ state: { taskId } })
   
  }

  return (
    <div className="task-page"> 
    <ToastContainer/>
    <Loader loading={Loading} />
      <div className="box">
        <div className="d-flex">
        {!showProjectSession &&(
          <>
          <Col md={2}>
            <Form.Control type="text" value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
 placeholder="Search Task Name" />
          </Col>

          <Col md={2} className="ms-4">
            <Form.Select  value={projectFilter}
              onChange={(e) => setprojectFilter(e.target.value)}
>
              <option value=''>All Projects</option>
              {project.map((projectname)=>{
                return <option key={projectname.projectId}>{projectname.projectName}</option>
              })}
            </Form.Select>
          </Col>

          <Col md={2} className="ms-4">
            <Form.Select  value={priorityFilter}
              onChange={(e) => setPriorityFilter(e.target.value)}
>
              <option value=''>All Priorities</option>
              <option>High</option>
              <option>Medium</option>
              <option>Low</option>
              <option>Critical</option>
            </Form.Select>
          </Col>
          <Col md={2} className="ms-4">
            <Form.Select  value={statusfilter}
              onChange={(e) => setstatusfilter(e.target.value)} 
>
              <option value=''>All Status</option>
              <option>Open</option>
              <option>In progress</option>
              <option>OnHold</option>
              <option>Completed</option>  
              <option>Skipped</option>
              <option>To be Tested</option>
 
            </Form.Select>
          </Col>
         
          <Col md={2} className="ms-4">
            <Form.Control type="date" value={dueDateFilter}
              onChange={(e) => setDueDateFilter(e.target.value)}/>
          </Col></>
        )}
          {(user.permission.includes(4)===true||user.role===1 || user.role===2)&&(
          <Col md={1} className="">
          <button className="btn btn-primary ms-3 w-100" onClick={handleCreate}>Create Task</button>
          </Col>
          )}
        </div>
{!showProjectSession &&(
        <Table striped bordered hover responsive className="shadow-sm mt-3">
          <thead className="table-primary">
            <tr>
              <th>TaskId</th>
              <th>Task Name</th>
              <th>Project Name</th>
              <th>Reported Date</th>
              <th>Created By</th>
              
              <th>Status</th>
              <th>Assigned To</th>
              <th>Priority</th>
              <th>Due Date</th>
             
            </tr>
          </thead>
          <tbody>
            {currentTasks.map((task) => (
              <tr key={task.projectTaskId} onClick={()=>handleclick(task.projectTaskId)}>
                <td>TS-{task.projectTaskId}</td>
                <td>{task.taskName}</td>
                <td>{task.project}</td>
                <td>{new Date(task.dueDate).toISOString().split("T")[0]}</td>
                <td>{task.createdBy}</td>
               

                <td style={{
                        
                       
                        backgroundColor:
                        task.status === "Open"
                            ? "#ffc107"
                            : task.status === "InProgress"
                            ? "#198754"
                            : task.status === "OnHold"
                            ? "#17a2b8"
                            : task.status === "Completed"
                            ? "#28a745"
                            : task.status === "ToBeTested"
                            ? "#0d6efd"
                            : task.status === "ReadyToDeploy"
                            ? "#198754"
                            : "#dc3545",
                        color: "white",
                        alignContent:"center",
                        textAlign: "center",
                      }}
                    >
                      {getStatusName(task.status)}
                  
                </td>

                <td>{getAssignedToName(task.assignedToPerson)}</td>

                <td style={{                         
                        backgroundColor:
                      task.priority === "High"
                        ? "#d32121"
                        : task.priority === "Medium"
                        ? "#d4f004"
                        : task.priority === "Low"
                        ? "#04f0d1"
                        : task.priority === "Critical"
                        ? "#f00404"
                        : "#f0040f",
                        alignContent:"center",
                        color: "white",
                    }}
                  >
                   
                    {getPriorityName(task.priority)}
                </td>
                <td>{new Date(task.dueDate).toISOString().split("T")[0]}</td>
              
              </tr>
            ))}
   
          </tbody>
{/* Pagination Navigation */}
<tr>
  <td colSpan={8}>

 
<div className="pagination-container mt-3 d-flex justify-content-center">
  <nav>
    <ul className="pagination">
      {/* Previous Button */}
      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
        <button
          className="page-link"
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </button>
      </li>

      {/* Page Number Buttons */}
      {generatePageNumbers().map((pageNumber) => (
        <li
          key={pageNumber}
          className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        </li>
      ))}

      {/* Next Button */}
      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
        <button
          className="page-link"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
</div>

</td>
</tr>
        </Table>
  
        
        ) }

        {/* Add Project */}
{showProjectSession && (

<form onSubmit={AddTask}>
          <Table striped bordered hover responsive className="shadow-sm mt-3">
            <thead className="table-primary">
              <tr>
                <th>Task Name</th>
                <th>Project Name</th>
                <th>Due Date</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    value={newTask.taskName} // Use newBug first, fallback to default bug
                    onChange={(e) =>
                      setNewtask((prev) => ({
                        ...prev,
                        taskName: e.target.value,
                      }))
                    }
                    name="taskName"
                    id="taskName" className="form-control" required
                  />
                </td>
                <td>
                <select name="project" id="project" onChange={(e)=>setNewtask({
                  ...newTask,
                  project:e.target.value
                })} required className="form-control" >
                  <option value=""required>Select Project</option>
                  {project.map((projectname)=>{
                return <option key={projectname.projectId} value={projectname.projectId}>{projectname.projectName}</option> 
              })}
                </select>
                </td>

                <td>
                  <input
                    type="date"
                    name="dueDate"
                    value={newTask.dueDate} // Use newBug first, fallback to default bug
                    onChange={(e) =>
                      setNewtask((prev) => ({
                        ...prev,
                        dueDate: e.target.value,
                      }))
                    }
                    defaultValue={""} className="form-control" required
                  />
                </td>

                <td
                  style={{
                    backgroundColor: getPriorityColor(newTask.priority),
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  <select
                    name="priority"
                    value={newTask.priority} // Use newBug first, fallback to default bug
                    onChange={(e) =>
                      setNewtask((prev) => ({
                        ...prev,
                        priority: e.target.value,
                      }))
                    } className="form-control"
                  >
                    {priority.map((priorityData) => (
                      <option value={priorityData.id} key={priorityData.id}>
                        {priorityData.name}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
              <br />
              <tr>
              <th className="thead table-primary">Assigned To</th>
<td className="tdata" style={{ backgroundColor: "#ebecedd7" }}>
  <select
    name="assignedToPerson"
    id="assignedToPerson"
    className="form-control"
    value={newTask.assignedToPerson}
    onChange={(e) =>
      setNewtask({
        ...newTask,
        assignedToPerson: e.target.value,
      })
    }
    required
  >
    <option value="">Select a person</option> {/* Default empty option */}
    {users.map((data) => (
      <option key={data.userId} value={data.userId}>
        {data.userName}
      </option>
    ))}
  </select>

  {/* Validation Message */}
  {!newTask.assignedToPerson && (
    <small className="text-danger">Assigned To is required!</small>
  )}
</td>
{user.role === 1 && (
                          <>
                            <th className="table-primary">Expected Date</th>
                            <td
                              className="tdata"
                              style={{ backgroundColor: "#ebecedd7" }}
                              colSpan="2"
                            >
                              <input
                                type="date"
                                value={newTask.expectedDate}
                                name="expectedDate" className="form-control"
                                onChange={(e) =>
                                  setNewtask((prev) => ({
                                    ...prev,
                                    expectedDate: e.target.value,
                                  }))
                                }
                              />
                            </td>
                          </>
                        )}
                <th className="thead table-primary">Testers</th>
                <td
                      className="tdata"
                      style={{ backgroundColor: "#ebecedd7" }}
                    >
                 <select name="testers" id="testers" className="form-control" value={newTask.testers}
                  onChange={(e)=>setNewtask({
                          ...newTask,
                          testers:e.target.value
                        })} >
                          {users.map((data)=>(
                            <option key={data.userId} value={data.userId}>{data.userName}</option>
                          ))}
                        </select>
                    </td>
              </tr>
              <br />
              <tr className="mt-5" style={{ height: "60px" }}>
                <th className="table-primary align-items-center">
                  Description
                </th>
                <td
                  style={{ backgroundColor: "#ebecedd7" }}
                  className=""
                  colSpan="6"
                >
                  <input
                    type="text"
                    name="description"
                    id="description"
                    className="text-start form-control"
                    value={newTask.description}
                    onChange={(e) =>
                      setNewtask((prev) => ({
                        ...prev,
                        description: e.target.value,
                      }))
                    }
                  />
                </td>
              </tr>
              {/* <tr>
                      <td colSpan="7 ">
                        <label htmlFor="note" className="fs-5">Add Note</label>
                        <input type="text" name="note" id="note" className="w-100 p-2" value={newTask.note}  onChange={(e) =>
                            setNewtask((prev) => ({
                              ...prev,
                              note: e.target.value,
                            }))
                          } />
                      </td>
                    </tr> */}
            
              <tr>
                <td colSpan="7">
               
                  <button className="btn btn-warning w-100" type="submit">
                    create Task
                  </button>
               
                </td>
              </tr>
            </tbody>
          </Table>
        </form>

)}

      </div>
     
    </div>
  );
};

export default Tasks;
